import usePercentageAnimation from '../../hooks/usePercentageAnimation';

export default function WhatSetsApart() {
    // Create animation hooks for each skill item
    const expertFaculty = usePercentageAnimation(100, 2000, 200);
    const curriculum = usePercentageAnimation(100, 2000, 400);
    const programs = usePercentageAnimation(100, 2000, 600);
    const trackRecord = usePercentageAnimation(100, 2000, 800);
    const globalReach = usePercentageAnimation(100, 2000, 1000);
    const learning = usePercentageAnimation(100, 2000, 1200);

    return (
        <>
            <section id="what-sets-us-apart-section">
                <div className="what-sets-us-apart-container">
                    <div className="what-sets-us-apart-content">
                        <div className="what-sets-us-apart-left">
                            <h2 className="section-title">What Sets Us Apart</h2>

                            <div className="skills-list">
                                <div ref={expertFaculty.ref} className="skill-item">
                                    <div className="skill-info">
                                        <span className="skill-name">Expert Faculty</span>
                                        <span className="skill-percentage">{expertFaculty.percentage}%</span>
                                    </div>
                                    <div className="skill-bar">
                                        <div className="skill-progress"></div>
                                    </div>
                                </div>

                                <div ref={curriculum.ref} className="skill-item">
                                    <div className="skill-info">
                                        <span className="skill-name">Comprehensive Curriculum</span>
                                        <span className="skill-percentage">{curriculum.percentage}%</span>
                                    </div>
                                    <div className="skill-bar">
                                        <div className="skill-progress"></div>
                                    </div>
                                </div>

                                <div ref={programs.ref} className="skill-item">
                                    <div className="skill-info">
                                        <span className="skill-name">Specialized Programs</span>
                                        <span className="skill-percentage">{programs.percentage}%</span>
                                    </div>
                                    <div className="skill-bar">
                                        <div className="skill-progress"></div>
                                    </div>
                                </div>

                                <div ref={trackRecord.ref} className="skill-item">
                                    <div className="skill-info">
                                        <span className="skill-name">Successful Students Track Record</span>
                                        <span className="skill-percentage">{trackRecord.percentage}%</span>
                                    </div>
                                    <div className="skill-bar">
                                        <div className="skill-progress"></div>
                                    </div>
                                </div>

                                <div ref={globalReach.ref} className="skill-item">
                                    <div className="skill-info">
                                        <span className="skill-name">Global Reach</span>
                                        <span className="skill-percentage">{globalReach.percentage}%</span>
                                    </div>
                                    <div className="skill-bar">
                                        <div className="skill-progress"></div>
                                    </div>
                                </div>

                                <div ref={learning.ref} className="skill-item">
                                    <div className="skill-info">
                                        <span className="skill-name">State-of-the-Art Learning</span>
                                        <span className="skill-percentage">{learning.percentage}%</span>
                                    </div>
                                    <div className="skill-bar">
                                        <div className="skill-progress"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="what-sets-us-apart-right">
                            <div className="what-sets-us-apart-image">
                                <img src="/images/what-sets-apart-us.jpeg" alt="Music Education Excellence" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
} 